import { Article } from 'services/ContentfulService/models/articles'
import { isPositiveNumber } from 'lib/undefinedHelpers/numbers'

export const getArticleCategory = (article: Article): string => {
	if (isPositiveNumber(article?.topics?.length)) {
		return article.topics[0].name
	} else if (isPositiveNumber(article?.products?.length)) {
		return article.products[0].name
	}
	return 'Finance'
}
